class InputFieldFormatting {
  static formatPhoneNumberInputField(input: string) {
    const first3 = input.substring(0, 3);
    const mid3 = input.substring(3, 6);
    const last4 = input.substring(6, 10);

    return `${first3}${mid3 ? '-' : ''}${mid3}${last4 ? '-' : ''}${last4}`;
  }

  static validEmailFormat(input: string) {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(input);
  }

  static formatS3ImageSrc(src: string) {
    const { hostname, pathname } = new URL(src);
    const s3Bucket = hostname.substring(0, hostname.indexOf('.s3'));
    return `s3://${s3Bucket}${pathname}`;
  }
}

export default InputFieldFormatting;
